import { Component } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router, ActivatedRoute } from "@angular/router";
import { AccountService, TestService } from "../../../api/services";
import { GlobalApp } from "../../../tools/global";
import { LoginLocal } from "../../../api/models";
import { ForgotPasswordService } from "../../../api/services/forgot-password.service";

@Component({
  selector: "reset-password",
  templateUrl: "./reset-password.component.html",
})
export class ResetPasswordComponent {
  public password: string = "";
  public confirmPassword: string = "";
  public errorMessage: string = "";
  public resetToken: string = "";
  public passwordReset: boolean = false;

  constructor(
    private accountService: AccountService,
    private router: Router,
    private globalApp: GlobalApp,
    private forgotPasswordService: ForgotPasswordService,
    private route: ActivatedRoute
  ) {
    this.route.paramMap.subscribe((params) => {
      this.resetToken = params.get("resetToken");

      if (this.resetToken === null || this.resetToken === "") {
        this.router.navigate(["/"]);
      }
    });
  }

  changePassword() {
    this.errorMessage = "";
    if (this.password !== this.confirmPassword) {
      this.errorMessage = "Passwords do not match";
    } else {
      this.forgotPasswordService
        .forgotPasswordSubmitPasswordReset({
          resetToken: this.resetToken,
          newPassword: this.password,
        })
        .subscribe((result) => {
          if (result) {
            this.passwordReset = true;
          } else {
            this.errorMessage = "Failed to reset password";
          }
        });
    }
  }
}
